export const LOCAL_DELIVERY_VIEW_LIST = 'LOCAL_DELIVERY_VIEW_LIST';
export const LOCAL_DELIVERY_CREATE = 'LOCAL_DELIVERY_CREATE';
export const LOCAL_DELIVERY_EDIT = 'LOCAL_DELIVERY_EDIT';
export const LOCAL_DELIVERY_VIEW = 'LOCAL_DELIVERY_VIEW';
export const LOCAL_DELIVERY_ACCEPT = 'LOCAL_DELIVERY_ACCEPT'
